const small_flu = `
C
|
o-C
| |
| o-H1N1
| |
| o-H2N3
|
o-C
  |
  o-H3N8
  |
  o-C
    |
    o-H3N1
    |
    o-H3N2
`;
export default small_flu;
